// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class Message {
}
Message.CODE_QUOTE = 1;
Message.CODE_INSTRUMENT = 2;
Message.CODE_MARGINCALL = 13;
Message.CODE_ACCOUNTSTATUS = 14;
Message.CODE_OPENPOSITION = 17;
Message.CODE_CLOSEPOSITION = 18;
Message.CODE_OPENORDER = 27;
Message.CODE_INSTRUMENT_TYPE = 31;
Message.CODE_PFIX_LOGON_MESSAGE = 42;
Message.CODE_USER_GROUP = 41;
Message.CODE_CANCEL_ORDER_MESSAGE = 46;
Message.CODE_REPLACE_ORDER_MESSAGE = 47;
Message.CODE_BUSINESS_REJECT_MESSAGE = 49;
Message.CODE_TRADE = 50;
Message.CODE_TEXT_MESSAGE = 51;
Message.CODE_NEWS_MESSAGE = 52;
Message.CODE_NEWS_REQUEST_MESSAGE = 53;
Message.CODE_PFIX_LOGOUT_MESSAGE = 56;
Message.CODE_PFIX_PING_MESSAGE = 57;
Message.CODE_PFIX_CHANGE_PASSWORD_REQUEST = 64;
Message.CODE_PFIX_PROPERTY_MESSAGE = 68;
Message.CODE_PFIX_REPORT_REQUEST_MESSAGE = 69;
Message.CODE_SUBSCRIBE_MESSAGE = 71;
Message.CODE_PFIX_XML_MESSAGE = 72;
Message.CODE_NEW_ORDER_MESSAGE = 73;
Message.CODE_PFIX_HELLO_MESSAGE = 75;
Message.CODE_ACCOUNT_OPERATION_REQUEST_MESSAGE = 76;
Message.CODE_ACCOUNT_OPERATION_CONFIRM_MESSAGE = 77;
Message.CODE_ACCOUNT_OPERATION_REQUEST_INFO_MESSAGE = 78;
Message.CODE_SUBSCRIBE_RESPONSE_MESSAGE = 84;
Message.CODE_SESSION_MESSAGE = 85;
Message.CODE_CROSSRATE_MESSAGE = 87;
Message.CODE_ACCOUNOPERATION_MESSAGE = 88;
Message.CODE_NEWS_SUBSCRIBE_MESSAGE = 89;
Message.CODE_NEWS_SUBSCRIBE_RESPONSE = 90;
Message.CODE_SOURCE_LIST = 91;
Message.CODE_REPORT_TYPE_MESSAGE = 92;
Message.CODE_SUBSCRIPTION_STRATEGY_MESSAGE = 97;
Message.CODE_SUBSCRIPTION_STRATEGY_REQUEST_MESSAGE = 98;
Message.CODE_TRADING_SYSTEM_MESSAGE = 99;
Message.CODE_TRADING_SYSTEM_REMOVE_MESSAGE = 100;
Message.CODE_QUOTE2 = 102;
Message.CODE_QUOTE3 = 103;
Message.CODE_QUOTE4 = 104;
Message.CODE_ROUTE = 105;
Message.CODE_ORDER_HISTORY = 106;
Message.CODE_PFIX_QUOTE2_AGGREGATED = 111;
Message.CODE_INSTRUMENT_PRICES = 113;
Message.CODE_INSTRUMENT_DAY_BAR = 114;
Message.CODE_TRADE_SESSION_STATUS_MESSAGE = 119;
Message.CODE_PFIX_MODIFY_POSITION = 121;
Message.CODE_PFIX_BRANDING_RULES_REQ = 122;
Message.CODE_PFIX_BRANDING_RULES_RESP = 123;
Message.CODE_PFIX_TRADE_SESSION_SWITCH = 124;
Message.CODE_PFIX_PRODUCT_MESSAGE = 125;
Message.CODE_PFIX_PRODUCT_DOCUMENT_REQ = 126;
Message.CODE_PFIX_PRODUCT_DOCUMENT_RESP = 127;
Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_REQ = 128;
Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_RESP = 129;
Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_HISTORY_REQ = 130;
Message.CODE_PFIX_SOAP_REQ = 401;
Message.CODE_PFIX_SOAP_RESP = 402;
Message.CODE_PFIX_HISTORY_REQ = 403;
Message.CODE_PFIX_HISTORY_RESP = 404;
Message.CODE_COMMISSION_PLAN_MESSAGE = 409;
Message.CODE_MARGIN_REQ = 410;
Message.CODE_MARGIN_RESP = 411;
Message.CODE_SPREAD_PLAN_MESSAGE = 413;
Message.CODE_ASSET_TYPE_MESSAGE = 414;
Message.CODE_CROSSRATES_PLAN_MESSAGE = 415;
Message.CODE_PFIX_MAM_GROUP_MESSAGE = 416;
Message.CODE_PFIX_RISK_PLAN_MESSAGE = 417;
Message.CODE_INSTRUMENT_LIST_REQUEST = 418;
Message.CODE_INSTRUMENT_LIST_RESPONSE = 419;
Message.CODE_INSTRUMENT_STRIKES_REQUEST = 420;
Message.CODE_INSTRUMENT_STRIKES_RESPONSE = 421;
Message.CODE_INSTRUMENT_REQUEST = 422;
Message.CODE_INTERESTS_ON_BALANCE_PLAN_MESSAGE = 423;
Message.CODE_INIT_DATA_REQUEST = 428;
Message.CODE_OPTIONS_CHAIN_REQUEST = 429;
Message.CODE_SWAP_PLAN = 430;
Message.CODE_PFIX_COMPRESSED_MESSAGE = 432;
Message.CODE_SUBSCRIBE_FOR_CROSSES_MESSAGE = 433;
Message.CODE_YTM_RESPONSE = 435;
Message.CODE_YTM_REQUEST = 436;
Message.CODE_HISTORY_CHANGED_RANGE = 437;
Message.CODE_TRADING_UNLOCK_MESSAGE = 438;
Message.CODE_TRADING_UNLOCK_MESSAGE_RESPONSE = 439;
Message.CODE_PFIX_CHANGE_TRADING_PASSWORD_REQUEST = 440;
Message.CODE_PFIX_TRADE_INSTRUMENT = 441;
Message.CODE_ONETIME_PASSWORD_MESSAGE = 442;
Message.CODE_RISK_WARN_MESSAGE = 443;
Message.CODE_INFORMATION_MESSAGE = 450;
Message.CODE_PFIX_REFRESH_TOKEN = 451;
Message.CODE_PFIX_ALGORITHM_SUBSCRIBE_MESSAGE = 453;
Message.CODE_PFIX_ALGORITHMS_AVAILABLE_MESSAGE = 454;
Message.CODE_PFIX_ALGORITHM_GAINERS_LOSERS_MESSAGE = 455;
Message.CODE_PFIX_ALGORITHM_HIGH_LOW_MESSAGE = 456;
Message.CODE_REQUEST_RECOVERY_PASSWORD_MESSAGE = 460;
Message.CODE_RECOVERY_CHANGE_REQUEST = 461;
Message.CODE_RECOVERY_CHANGE_RESPONSE = 462;
Message.CODE_PFIX_PORTFOLIO_SYSTEM_MESSAGE = 463;
Message.CODE_PFIX_PORTFOLIO_INVESTOR_MESSAGE = 464;
Message.CODE_PFIX_PORTFOLIO_MODEL_REQUEST_MESSAGE = 466;
Message.CODE_PFIX_PORTFOLIO_MODEL_MESSAGE = 467;
Message.CODE_PFIX_BROKER_RESPONSE_MESSAGE = 470;
Message.CODE_PFIX_BROKER_MESSAGE_RESPONSE_CASE_RESPONSE = 471;
Message.CODE_REPORT_GROUP_REQUEST = 472;
Message.CODE_REPORT_GROUP_RESPONSE = 473;
Message.CODE_PFIX_CUSTODIAL_PLAN_MESSAGE = 477;
Message.CODE_PFIX_EXERCISE_REQUEST_MESSAGE = 478;
Message.CODE_PFIX_PORTFOLIO_STATISTICS_REQUEST = 479;
Message.CODE_PFIX_PORTFOLIO_STATISTICS_RESPONSE = 480;
Message.CODE_PFIX_PORTFOLIO_REALTIME_STATISTICS = 481;
Message.CODE_ALERT_MESSAGE = 483;
Message.CODE_CREATE_ALERT_MESSAGE = 484;
Message.CODE_REPLACE_ALERT_MESSAGE = 485;
Message.CODE_CONTROL_ALERT_COMMAND_MESSAGE = 486;
Message.CODE_PFIX_TOKEN_VERIFY_REQUEST = 487;
Message.CODE_PFIX_TOKEN_VERIFY_RESPONSE = 488;
Message.CODE_GET_SNAPSHOT_REQUEST = 489;
Message.CODE_GET_SNAPSHOT_RESPONSE = 490;
Message.CODE_PFIX_EXTERNAL_LINK_MESSAGE = 492;
Message.CODE_PFIX_EXTERNAL_LINK_REMOVE_MESSAGE = 493;
Message.CUSTOM_LIST_MESSAGE = 494;
Message.CODE_PFIX_ALGORITHM_TOP_VOLUME_MESSAGE = 503;
Message.CODE_PFIX_ALGORITHM_HISTORICAL_GAINER_LOSER_TOPS_MESSAGE = 505;
Message.BM_HISTORY_REQUEST = 507;
Message.BM_HISTORY_RESPONSE = 508;
Message.BM_COUNTER_MESSAGE = 509;
Message.CODE_PFIX_ALGORITHM_HEATMAP_MESSAGE = 510;
Message.CODE_PRICE_LIMITS_MESSAGE = 511;
Message.CODE_PFIX_FUNDING_RATE_MARKUP_PLAN_MESSAGE = 513;
Message.CODE_PFIX_CLOSE_ACCOUNT_REQUEST_MESSAGE = 514;
Message.CODE_PFIX_CLOSE_ACCOUNT_RESPONSE_MESSAGE = 515;
Message.CODE_PFIX_CLOSE_ACCOUNT_CANCEL_REQUEST_MESSAGE = 516;
Message.CUSTOM_LIST_REQUEST = 521;
Message.CODE_PFIX_ACCOUNT_FOLLOWER_REQ = 522;
Message.CODE_PFIX_ACCOUNT_FOLLOWER_RESP = 523;
Message.CODE_PFIX_ADD_2FA_REQUEST = 524;
Message.CODE_PFIX_ADD_2FA_RESPONSE = 525;
Message.CODE_PFIX_CONFIRM_2FA_REQUEST = 526;
Message.CODE_PFIX_CONFIRM_2FA_RESPONSE = 527;
Message.CODE_USER_DEVICES_REQUEST = 528;
Message.CODE_USER_DEVICES_RESPONSE = 529;
Message.CODE_AL_REQUEST = 530;
Message.CODE_AL_RESPONSE = 531;
Message.CODE_QUOTES_REQUEST = 532;
Message.CODE_MODIFY_TRADE_MESSAGE = 533;
Message.CODE_TRADING_WEBHOOK_REQUEST = 534;
Message.CODE_TRADING_WEBHOOK_RESPONSE = 535;
Message.CODE_TRADING_WEBHOOK_LIST_REQUEST = 539;
Message.CODE_TRADING_WEBHOOK_LIST_RESPONSE = 540;
Message.CODE_OTT_REQUEST = 541;
Message.CODE_OTT_RESPONSE = 542;
Message.CODE_PFIX_ACCEPTED_MESSAGE = 4001;
Message.CodesString = (() => {
    const result = {};
    const keys = Object.keys(Message);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (typeof Message[key] === 'number') {
            result[Message[key]] = key;
        }
        else {
            continue;
        }
    }
    return result;
})();
